import type { PaginatedResponse } from "@/features/profiles/services/profiles/types";
import type { Creator } from "@/features/creators/services/creatorService";
import type { PaymentDocument } from "./payment-document.types";
import type { PaymentCreatorBankAccount } from "./bank-account.types";

export enum PaymentStatus {
  PENDING = "PENDING",
  SCHEDULED = "SCHEDULED",
  PAID = "PAID",
  ERROR = "ERROR",
}

export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  [PaymentStatus.PENDING]: "Pendente",
  [PaymentStatus.SCHEDULED]: "Agendado",
  [PaymentStatus.PAID]: "Pago",
  [PaymentStatus.ERROR]: "Erro",
};

export interface PaymentEmployee {
  id: string;
  name: string;
  email?: string | null;
  avatarUrl?: string | null;
}

export interface Payment {
  id: string;
  creatorId: string;
  creatorBankAccountId: string;
  status: PaymentStatus;
  value: number;
  paymentDate: string;
  referencePaymentDate?: string | null;
  createdAt: string;
  createdById: string;
  lastUpdatedAt?: string | null;
  lastUpdatedById?: string | null;
  createdBy?: PaymentEmployee;
  bankAccount?: PaymentCreatorBankAccount;
  creator?: Creator;
  lastUpdatedBy?: PaymentEmployee | null;
  documents?: PaymentDocument[];
}

export type PaginatedPaymentsResponse = PaginatedResponse<Payment>;

export interface GetPaymentsParams {
  page?: number;
  limit?: number;
  status?: PaymentStatus | "all";
  creatorId?: string;
  creatorBankAccountId?: string;
  value?: number;
  paymentDateStart?: string;
  paymentDateEnd?: string;
  referencePaymentDateStart?: string;
  referencePaymentDateEnd?: string;
  search?: string;
  sortBy?: "paymentDate" | "createdAt" | "value";
  order?: "asc" | "desc";
}

export interface CreatePaymentPayload {
  creatorId: string;
  creatorBankAccountId: string;
  status: PaymentStatus;
  value: number;
  paymentDate: string;
  referencePaymentDate?: string | null;
  documentIds?: string[];
}

export interface UpdatePaymentPayload {
  id: string;
  creatorId?: string;
  creatorBankAccountId?: string;
  status?: PaymentStatus;
  value?: number;
  paymentDate?: string;
  referencePaymentDate?: string | null;
}

export interface PaymentListFilters {
  search?: string;
  status?: PaymentStatus | "all";
  creatorId?: string;
  page?: number;
  limit?: number;
  sortBy?: "paymentDate" | "createdAt" | "value";
  order?: "asc" | "desc";
}

